// extracted by mini-css-extract-plugin
module.exports = {"summary":"payments_summary__2IZVy","button":"payments_button__2w6VY"};